import useFilters from "@/composables/useFilters";
import { InboxModuleType } from "@/types/inboxModule.type";
import { reactive, ref } from "@vue/composition-api";
import { StatusFilterNameType, StatusType } from "@/types/filter.types";
import { ChatListMode } from "@saysimple-platform/dtos";

const filters = reactive({
    keyword: "",
    channels: [],
    tags: [],
    teams: [],
    sortBy: "newestEntry" as ChatListMode,
});

const searchString = ref("");
const page = ref(1);
const sortBy = ref("newestEntry" as ChatListMode);
const activeFilter = ref({
    page: page.value,
    keyword: searchString.value,
    sortBy: sortBy.value,
    channels: [],
    tags: [],
    teams: [],
    status: {
        title: "New",
        name: StatusFilterNameType.NEW,
        query: {
            status: StatusType.OPEN,
            assignedUser: null,
            assignedTeam: null,
        },
    },
});

// @NOTE Thom 03-04-23: Temporary solution to save time! if changes are required, we should refactor useFilters
export default function useEmailFilters() {
    return useFilters(filters, InboxModuleType.EMAIL, searchString, page, activeFilter, sortBy);
}
